import React, { useState } from 'react';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';

const AdminLayout = ({ children, title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-container">
      {/* Mobile sidebar */}
      <div className={`mobile-sidebar ${sidebarOpen ? 'open' : ''}`}>
        {sidebarOpen && (
          <div className="mobile-sidebar-overlay" onClick={() => setSidebarOpen(false)}>
            <div className="mobile-sidebar-content" onClick={(e) => e.stopPropagation()}>
              <button 
                className="mobile-sidebar-close"
                onClick={() => setSidebarOpen(false)}
              >
                &times;
              </button>
              <AdminSidebar mobile />
            </div>
          </div>
        )}
      </div>

      {/* Static sidebar for desktop */}
      <div className="desktop-sidebar">
        <AdminSidebar />
      </div>

      {/* Main content */}
      <div className="main-content">
        <AdminHeader setSidebarOpen={setSidebarOpen} title={title} />
        <main className="content-area">
          <div className="content-container">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout; 